import { UserSettingsLayout } from '@jarvis/platform-ui';

const SECTIONS = [
  { id: 'general', text: 'General', path: 'general' },
  { id: 'appearance', text: 'Appearance', path: 'appearance' },
  { id: 'editors', text: 'Editors', path: 'editors' },
  { id: 'about', text: 'About', path: 'about' }
];

export function SettingsPage() {
  return <UserSettingsLayout sections={SECTIONS} />;
}
